import WorkbenchWelcomeModal from '@/components/workbench/WorkbenchWelcomeModal.vue'
import { getInvitePromo } from '@/api/portal/invite'
import { shouldShowWelcome, markWelcomeShown } from '@/utils/workbenchWelcome'

export default {
  components: { WorkbenchWelcomeModal },
  data() {
    return {
      welcomeVisible: false,
      welcomePromo: {
        newMemberReward: 2000,
        inviterReward: 1000
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tryShowWelcome()
    })
  },
  methods: {
    tryShowWelcome() {
      if (!shouldShowWelcome()) {
        return
      }
      getInvitePromo()
        .then(res => {
          if (res.data) {
            this.welcomePromo = res.data
          }
          this.welcomeVisible = true
        })
        .catch(() => {
          this.welcomeVisible = true
        })
    },
    closeWelcome() {
      this.welcomeVisible = false
      markWelcomeShown()
    },
    onWelcomeLogin() {
      this.closeWelcome()
      this.goLogin()
    },
    onWelcomeInvite() {
      this.closeWelcome()
      if (this.loggedIn) {
        this.$router.push('/workbench/invite')
      } else {
        this.goLogin()
      }
    }
  }
}
